import React, { useCallback, useState } from "react";
import { Box, Button, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { dashboard2WeekNavSx } from "../dashboard2.styles";
import {
  dashboard2IconTouchTargetSx,
  dashboard2WeekNavLabelButtonSx
} from "../dashboard2-status.styles";
import { Dashboard2WeekPickerDialog } from "./Dashboard2WeekPickerDialog";

type Dashboard2WeekNavigationProps = {
  weekAnchor: DateTime;
  onPreviousWeek: () => void;
  onNextWeek: () => void;
  onWeekSelect: (week: DateTime) => void;
};

export const Dashboard2WeekNavigation: React.FC<Dashboard2WeekNavigationProps> = ({
  weekAnchor,
  onPreviousWeek,
  onNextWeek,
  onWeekSelect
}) => {
  const { t } = useTranslation();
  const [pickerOpen, setPickerOpen] = useState(false);

  const handleOpenPicker = useCallback(() => {
    setPickerOpen(true);
  }, []);

  const handleClosePicker = useCallback(() => {
    setPickerOpen(false);
  }, []);

  const weekLabel = t("_dashboard2_weekLabel", {
    week: weekAnchor.weekNumber,
    year: weekAnchor.year
  });

  return (
    <>
      <Box sx={dashboard2WeekNavSx}>
        <IconButton
          aria-label={t("_dashboard2_previousWeek")}
          onClick={onPreviousWeek}
          data-testid="dashboard2-previous-week"
          sx={dashboard2IconTouchTargetSx}
        >
          <ChevronLeft />
        </IconButton>
        <Button
          onClick={handleOpenPicker}
          variant="contained"
          color="inherit"
          sx={dashboard2WeekNavLabelButtonSx}
          data-testid="dashboard2-week-label"
          aria-label={t("_dashboard2_weekPickerOpen", { week: weekLabel })}
          aria-haspopup="dialog"
        >
          {weekLabel}
        </Button>
        <IconButton
          aria-label={t("_dashboard2_nextWeek")}
          onClick={onNextWeek}
          data-testid="dashboard2-next-week"
          sx={dashboard2IconTouchTargetSx}
        >
          <ChevronRight />
        </IconButton>
      </Box>

      <Dashboard2WeekPickerDialog
        open={pickerOpen}
        weekAnchor={weekAnchor}
        onClose={handleClosePicker}
        onSelectWeek={onWeekSelect}
      />
    </>
  );
};
